module.exports = __webpack_public_path__ + "00281aff08043f48de74581cbbb93890.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/coat.png
// module id = 1260
// module chunks = 0